<template>
    <div v-if="hasAccessDelete(FUNCTIONALITY) && hasUpdatableForecasts" class="wrapper">
        <div class="headline">Forecasts</div>
        <div class="items"><ItemManager :item="convertedItem" :do-save="doSave" @saved="doSave = false;" /></div>
        <div><ClientColorButton :class-name="'button'" @click="doSave = true;">Update selected forecasts</ClientColorButton></div>
    </div>
</template>
<script>
import ItemManager from "@/components/forecasts/elements/catalogue/CatalogueItemManager";
import { FUNCTIONALITY } from "@/components/forecasts/constants";
import { mapActions, mapGetters } from "vuex";
import { convertItem } from "@/components/forecasts/model/item";
import { canAddItemToAtLeastOneForecast } from "@/components/forecasts/validation/forecastValidator";

export default {
    components: { ItemManager },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            doSave: false,
            FUNCTIONALITY
        };
    },
    async created() {
        await this.populate();
        await this.populateItems();
        await this.hasUpdatableForecasts();
    },
    computed: {
        ...mapGetters("forecast", { forecasts: "updatable" }),
        ...mapGetters("forecast", { getItems: "getItemsShallow" }),
        convertedItem() {
            return convertItem(this.item);
        }
    },
    methods: {
        ...mapActions("forecast", { populate: "populate" }),
        ...mapActions("forecast", { populateItems: "populateItemsShallow" }),
        async hasUpdatableForecasts() {
            for (let fc of this.forecasts) {
                let items = await this.getItems(fc.id);
                if (items.some(item => item.id === this.convertedItem.id)) {
                    return true;
                }
            }
            return canAddItemToAtLeastOneForecast(this.forecasts, this.convertedItem);
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../css/forecasts.scss";
.wrapper {
    text-transform: uppercase;
    background-color: $color5;
    padding: 10px;
    .headline {
        font-weight: bold;
        padding-bottom: 10px;
    }
    .items {
        padding-left: 10px;
    }
    .button {
        width: 100%;
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// ItemDetail.vue?c792a462